import { 
  INTERVALS_GET_DAYS,
  INTERVALS_GET_INTERVALS, 
  INTERVALS_GET_OFFICE_INFO,
  INTERVALS_GET_OFFICE_STATS,
  INTERVALS_SELECT_DAY,
  INTERVALS_RESET_DATA,
  PENDING, FULFILLED, REJECTED, 
} from '../globals';


export const initialState = {
  serviceState: {
    selectedDateId: '',
    selectedDateDay: null,
  },
  daysData: {
    isLoading: false,
    status: false,
    error: false,
    data: [],
    errorMessage: [],
  },
  intervalsData: {
    isLoading: false,
    status: false,
    error: false,
    data: [],
    errorMessage: [],
  },
  officeData: {
    isLoading: false,
    status: false,
    error: false,
    data: [],
    errorMessage: [],
  },
  serviceData: {
    isLoading: false,
    status: false,
    error: false,
    data: [],
    errorMessage: [],
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case `${INTERVALS_GET_DAYS}_${PENDING}`:
      return {
        ...initialState,
        daysData: {
          isLoading: true,
          status: false,
          error: false,
          data: [],
          errorMessage: [],
        },
        serviceState: {
          ...state.serviceState,
        },
      };

    case `${INTERVALS_GET_DAYS}_${FULFILLED}`:
      return {
        ...state,
        daysData: {
          ...state.daysData,
          isLoading: false,
          status: action.payload.status,
          data: action.payload.data,
        }
      };

    case `${INTERVALS_GET_DAYS}_${REJECTED}`: 
      return {
        ...state,
        daysData: {
          ...state.daysData,
          isLoading: false,
          status: false,
          error: true,
          errorMessage: action.payload.error,
        }
      };



    case `${INTERVALS_GET_INTERVALS}_${PENDING}`:
      return {
        ...state,
        intervalsData: {
          ...state.intervalsData,
          isLoading: true,
        }
      };

    case `${INTERVALS_GET_INTERVALS}_${FULFILLED}`:
      return {
        ...state,
        intervalsData: {
          ...state.intervalsData,
          isLoading: false,
          status: action.payload.status,
          data: action.payload.data,
        }
      };

    case `${INTERVALS_GET_INTERVALS}_${REJECTED}`: 
      return {
        ...state,
        intervalsData: {
          ...state.intervalsData,
          isLoading: false,
          status: false,
          error: true,
          errorMessage: action.payload.error,
        }
      };



    case `${INTERVALS_GET_OFFICE_INFO}_${PENDING}`:
      return {
        ...state,
        officeData: {
          ...state.officeData,
          isLoading: true,
        }
      };

    case `${INTERVALS_GET_OFFICE_INFO}_${FULFILLED}`:
      return {
        ...state,
        officeData: {
          ...state.officeData,
          isLoading: false,
          status: action.payload.status,
          data: action.payload.data,
        }
      };

    case `${INTERVALS_GET_OFFICE_INFO}_${REJECTED}`: 
      return {
        ...state,
        officeData: {
          ...state.officeData,
          isLoading: false,
          status: false,
          error: true,
          errorMessage: action.payload.error,
        }
      };

    case `${INTERVALS_GET_OFFICE_STATS}_${PENDING}`:
      return {
        ...state,
        serviceData: {
          ...state.serviceData,
          isLoading: true,
        }
      };

    case `${INTERVALS_GET_OFFICE_STATS}_${FULFILLED}`:
      return {
        ...state,
        serviceData: {
          ...state.serviceData,
          isLoading: false,
          status: action.payload.status,
          data: action.payload.data,
        }
      };

    case `${INTERVALS_GET_OFFICE_STATS}_${REJECTED}`:
      return {
        ...state,
        serviceData: {
          ...state.serviceData,
          isLoading: false,
          status: false,
          error: true,
          errorMessage: action.payload.error,
        }
      };


    case `${INTERVALS_SELECT_DAY}`:
      return {
        ...state,
        serviceState: {
          ...state.serviceState,
          selectedDateId: action.payload.dayId,
          selectedDateDay: action.payload.day,
        }
      };

    case `${INTERVALS_RESET_DATA}`:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default reducer;
